/* One place decides how money looks. Every screen formats through here, so a
   GBP quote never renders with an Australian dollar sign. */
export const CURRENCIES = [
  { code: "AUD", symbol: "A$", label: "Australian dollar (AUD)", locale: "en-AU", name: "Australian dollars" },
  { code: "GBP", symbol: "£", label: "British pound (GBP)", locale: "en-GB", name: "British pounds" },
  { code: "USD", symbol: "US$", label: "US dollar (USD)", locale: "en-US", name: "US dollars" },
];

const BY_CODE = CURRENCIES.reduce((m, c) => ({ ...m, [c.code]: c }), {});

export const currency = (code) => BY_CODE[String(code || "AUD").toUpperCase()] || BY_CODE.AUD;
export const currencySymbol = (code) => currency(code).symbol;

/* formatMoney(1234.5, "GBP")        -> "£1,234.50"
   formatMoney(1234.5, "USD", {dp:0}) -> "US$1,235"  */
export const formatMoney = (v, code = "AUD", { dp = 2 } = {}) => {
  const c = currency(code);
  const n = Number(v || 0);
  return `${n < 0 ? "-" : ""}${c.symbol}${Math.abs(n).toLocaleString(c.locale, {
    minimumFractionDigits: dp, maximumFractionDigits: dp,
  })}`;
};

export const formatMoney0 = (v, code = "AUD") => formatMoney(v, code, { dp: 0 });

/* Compact form for dashboards: A$1.2m / £340k */
export const formatMoneyShort = (v, code = "AUD") => {
  const sym = currencySymbol(code);
  const n = Number(v || 0);
  const a = Math.abs(n);
  const sign = n < 0 ? "-" : "";
  if (a >= 1_000_000) return `${sign}${sym}${(a / 1_000_000).toFixed(1)}m`;
  if (a >= 1_000) return `${sign}${sym}${(a / 1_000).toFixed(1).replace(/\.0$/, "")}k`;
  return `${sign}${sym}${a.toFixed(0)}`;
};

/* Tax treatment: EQUIPR is Australian registered, so overseas supplies are
   tax-free exports. AUD defaults to domestic GST. */
export const TAX_TREATMENTS = [
  { key: "domestic", label: "Domestic — GST 10%", rate: 0.1, taxLabel: "GST 10%" },
  { key: "export", label: "Export — No Tax Applicable", rate: 0, taxLabel: "No Tax Applicable" },
];

export const defaultTreatment = (code) => (String(code || "AUD").toUpperCase() === "AUD" ? "domestic" : "export");
export const treatment = (key) => TAX_TREATMENTS.find((t) => t.key === key) || TAX_TREATMENTS[0];
export const taxRate = (key) => treatment(key).rate;
export const taxLabel = (key) => treatment(key).taxLabel;
